export interface FeatureRelease {
  workItemId: number;
  title: string;
  closedDate: string | null;
  dayName: string | null;
  formatted: string | null;
  synopsis: string;
  commitCount: number;
  url: string | null;
}

export interface FeatureReleaseDayGroup {
  date: string;
  label: string;
  releases: FeatureRelease[];
}

const UNKNOWN_DATE = 'unknown';

/**
 * Group API-ordered releases (newest closed date first) into per-day groups
 * matching the Dev Activity card's day-header format. Releases with no closed
 * date collect into a trailing "Date unknown" group.
 */
export function groupReleasesByDate(releases: FeatureRelease[]): FeatureReleaseDayGroup[] {
  const groups: FeatureReleaseDayGroup[] = [];
  const byDate = new Map<string, FeatureReleaseDayGroup>();

  for (const item of releases) {
    const date = item.closedDate ?? UNKNOWN_DATE;
    let group = byDate.get(date);
    if (!group) {
      group = {
        date,
        label: item.closedDate ? `${item.dayName} (${item.formatted})` : 'Date unknown',
        releases: [],
      };
      byDate.set(date, group);
      groups.push(group);
    }
    group.releases.push(item);
  }

  // Keep the unknown-date group (if any) at the end.
  return [
    ...groups.filter(g => g.date !== UNKNOWN_DATE),
    ...groups.filter(g => g.date === UNKNOWN_DATE),
  ];
}
